{
  "$schema": "https://mux.run/theme.json",
  "name": "Catppuccin Frappe",
  "id": "catppuccin-frappe",
  "light": {
    "palette": {
      "neutral": "#303446",
      "ink": "#c6d0f5",
      "primary": "#8da4e2",
      "accent": "#f4b8e4",
      "success": "#a6d189",
      "warning": "#e5c890",
      "error": "#e78284",
      "info": "#81c8be"
    },
    "overrides": {
      "text-weak": "#b5bfe2",
      "syntax-comment": "#949cb8",
      "syntax-keyword": "#ca9ee6",
      "syntax-string": "#a6d189",
      "syntax-primitive": "#8da4e2",
      "syntax-variable": "#e78284",
      "syntax-property": "#99d1db",
      "syntax-type": "#e5c890",
      "syntax-constant": "#ef9f76",
      "syntax-operator": "#99d1db",
      "syntax-punctuation": "#c6d0f5",
      "syntax-object": "#e78284",
      "markdown-heading": "#ca9ee6",
      "markdown-text": "#c6d0f5",
      "markdown-link": "#8da4e2",
      "markdown-link-text": "#99d1db",
      "markdown-code": "#a6d189",
      "markdown-block-quote": "#e5c890",
      "markdown-emph": "#e5c890",
      "markdown-strong": "#ef9f76",
      "markdown-horizontal-rule": "#a5adce",
      "markdown-list-item": "#8da4e2",
      "markdown-list-enumeration": "#99d1db",
      "markdown-image": "#8da4e2",
      "markdown-image-text": "#99d1db",
      "markdown-code-block": "#c6d0f5"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#303446",
      "ink": "#c6d0f5",
      "primary": "#8da4e2",
      "accent": "#f4b8e4",
      "success": "#a6d189",
      "warning": "#e5c890",
      "error": "#e78284",
      "info": "#81c8be"
    },
    "overrides": {
      "text-weak": "#b5bfe2",
      "syntax-comment": "#949cb8",
      "syntax-keyword": "#ca9ee6",
      "syntax-string": "#a6d189",
      "syntax-primitive": "#8da4e2",
      "syntax-variable": "#e78284",
      "syntax-property": "#99d1db",
      "syntax-type": "#e5c890",
      "syntax-constant": "#ef9f76",
      "syntax-operator": "#99d1db",
      "syntax-punctuation": "#c6d0f5",
      "syntax-object": "#e78284",
      "markdown-heading": "#ca9ee6",
      "markdown-text": "#c6d0f5",
      "markdown-link": "#8da4e2",
      "markdown-link-text": "#99d1db",
      "markdown-code": "#a6d189",
      "markdown-block-quote": "#e5c890",
      "markdown-emph": "#e5c890",
      "markdown-strong": "#ef9f76",
      "markdown-horizontal-rule": "#a5adce",
      "markdown-list-item": "#8da4e2",
      "markdown-list-enumeration": "#99d1db",
      "markdown-image": "#8da4e2",
      "markdown-image-text": "#99d1db",
      "markdown-code-block": "#c6d0f5"
    }
  }
}
